import { api } from '@/plugins/axios.js'

export default {
  /**
   *
   * @param {Number} ibge - IBGE do município
   * @returns String
   */
  async getUltimaAtualizacao(ibge) {
    try {
      let response = await api.get('/app/ultima-atualizacao-dos-dados/' + ibge)
      if (response) {
        return response.data
      }
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * Retorna as microáreas do município
   * @param {*} ibge
   * @returns
   */
  async getMicroAreasPorMunicipio(ibge) {
    try {
      let microareas = []
      let response = await api.get('/app/' + ibge + '/microareas')
      if (response) {
        microareas = response.data
      }
      return microareas
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * Retorna as equipes do município
   * @param {*} ibge
   * @returns
   */
  async getEquipesPorMunicipio(ibge) {
    try {
      let equipes = []
      let response = await api.get('/app/v2/equipes/' + ibge)
      if (response) {
        equipes = response.data
      }
      return equipes
    } catch (error) {
      console.log(error)
    }
  },

  /**
   * Retorna as regras dos indicadores do município
   * @param {*} ibge
   * @returns
   */
  async getRegrasIndicadoresPorMunicipio(ibge) {
    try {
      let regras = []
      let response = await api.get(
        '/app/v2/indicadores-aps/' + ibge + '/regras'
      )
      if (response) {
        regras = response.data
      }
      return regras
    } catch (error) {
      console.log(error)
    }
  },
}
